import { fillDigits } from "./object";


const MONTHS = [
    null,
    [ "Jan", "January" ],
    [ "Feb", "February" ],
    [ "Mar", "March" ],
    [ "Apr", "April" ],
    [ "May", "May" ],
    [ "Jun", "June" ],
    [ "July", "July" ],
    [ "Aug", "August" ],
    [ "Sep", "September" ],
    [ "Oct", "October" ],
    [ "Nov", "November" ],
    [ "Dec", "December" ],
];

export function getMonthName(id, { abbreviated = false } = {}) {
    const names = MONTHS[id];
    if(!names) return "";

    return abbreviated ? names[0] : names[1];
}


export async function wait(ms) {
    await new Promise(resolve => setTimeout(resolve, ms));
}

export function parseDateWithTime(timestamp) {
    if(!timestamp) return "";
    
    const date = new Date(timestamp);
    const month = getMonthName(date.getMonth() + 1, { abbreviated: true });
    const day = date.getDate();
    const year = date.getFullYear();

    const _hour = date.getHours();
    const amOrPm = _hour < 12 ? "AM" : "PM";
    const hour = fillDigits((_hour%12 || 12), 2);
    const minute = fillDigits(date.getMinutes(), 2);
     
    return `${day} ${month} ${year}, ${hour}:${minute} ${amOrPm}`;
}

export function getRelativeDate(timestamp) {
    return "Eons ago";
}

export function getCurrentMonth(cached = true) {
    if(cached && localStorage.getItem("currentMonth")) {
        const month = Number(localStorage.getItem("currentMonth"));
        const year = Number(localStorage.getItem("currentYear"));

        return { month, year };
    }

    
    const date = new Date();

    let month = date.getMonth();
    let year = date.getFullYear();

    if(month === 0) year--;
    return { month, year };
}

export function setCurrentMonth({ month, year }) {
    localStorage.setItem("currentMonth", month);
    localStorage.setItem("currentYear", year);
}

export function getCurrentMonthPath() {
    const { month, year } = getCurrentMonth();
    return `${month}/${year}`;
}